export const PARTNER_SESSION_TIMEOUT_EVENT = "session-timeout-event";

export const PARTNER_SESSION_MAX_MS =
  Number(process.env.REACT_APP_PARTNER_SESSION_MAX_MS) || 16 * 60 * 60 * 1000;

export function partnerSessionStartedStorageKey(portalId) {
  return `naturals_${portalId}_session_started_at`;
}

export function markPartnerSessionStarted(portalId) {
  localStorage.setItem(partnerSessionStartedStorageKey(portalId), String(Date.now()));
}

export function clearPartnerSessionStarted(portalId) {
  localStorage.removeItem(partnerSessionStartedStorageKey(portalId));
}
